import { Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import { TeamBonusesComponent } from './team-bonuses.component';

@Injectable()
export class TeamBonusesDialog {
  constructor(private _dialog: DialogService) {
  }

  open(openedFromPersonalInfo: boolean): DialogRef {
    return this._dialog.open(TeamBonusesComponent, openedFromPersonalInfo);
  }
}
